<template>
  <section class="hero is-fullheight l-authentification">
    <div class="hero-body">
      <div
        v-if="!loading"
        class="columns is-gapless is-border has-background-white login">
        <div class="column is-5 has-background-white">
          <img
            :src="$configs.LOGO_LOGIN"
            :alt="$configs.COMPANY">
        </div>
        <div class="column is-7 columns is-gapless is-column is-padding-top is-padding-right">
          <form
            @submit.prevent="submitForm"
            class="is-margin-top-large is-margin-bottom-small">
            <div class="columns">
              <div class="column">
                <r-label
                  :label="'Nom'"
                  :value="lastName"
                  :for-id="'lastName'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'lastName'"
                  @input="val =>lastName = val"
                  :model="lastName"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="lastName"
                  data-type-cy="input"
                  data-value-cy="lastName">
                </v-input>
              </div>
              <div class="column">
                <r-label
                  :label="'Prénom'"
                  :value="firstName"
                  :for-id="'firstName'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'firstName'"
                  @input="val =>firstName = val"
                  :model="firstName"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="firstName"
                  data-type-cy="input"
                  data-value-cy="firstName">
                </v-input>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <r-label
                  :label="'Compte'"
                  :value="accountName"
                  :for-id="'accountName'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'accountName'"
                  @input="val =>accountName = val"
                  :model="accountName"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="accountName"
                  data-type-cy="input"
                  data-value-cy="accountName">
                </v-input>
              </div>
              <div class="column">
                <v-input
                  id="phone"
                  name="phone"
                  @input="phone = $event"
                  :model="phone"
                  :errors-bag="errors"
                  :input-type="'tel'"
                  :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                  v-validate="'required|min:10'"
                  data-vv-value-path="val"
                  data-vv-as="Téléphone"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="true"
                    :label="'Téléphone'"
                    :value="phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                  <p
                    class="control"
                    slot="addonLeft">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-phone-office"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <r-label
                  :label="'Email'"
                  :value="email"
                  :for-id="'email'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'email'"
                  @input="val =>email = val"
                  :model="email"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255|email'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="email"
                  data-type-cy="input"
                  data-value-cy="email">
                </v-input>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <address-input
                  :source="address"
                  :from-quickview="false"
                  :is-required="true"
                  @update="val => this.$set(this, 'address', val)">
                </address-input>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <r-label
                  :label="'Mot de passe'"
                  :value="password"
                  :for-id="'password'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'password'"
                  @input="val =>password = val"
                  :model="password"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="password"
                  data-type-cy="input"
                  data-value-cy="password">
                </v-input>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <r-label
                  :label="'Token'"
                  :value="token"
                  :for-id="'token'"
                  :is-required="true"></r-label>
                <v-input
                  :name="'token'"
                  @input="checkInvitationToken"
                  :model="token"
                  :has-addons="true"
                  v-validate="'required|min:2|max:255'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="token"
                  data-type-cy="input"
                  data-value-cy="token">
                </v-input>
                <div v-if="tokenIsValid === false">
                  <span class="is-danger">Ce token ne semble pas valide</span>
                </div>
              </div>
            </div>
            <div class="field is-margin-top">
              <div class="control">
                <button
                  type="submit"
                  class="button is-primary is-fullwidth"
                  :disabled="!canSubmit || loading"
                  :class="{'is-loading':loading}"
                  data-type-cy="button">
                  <span v-if="!loading">Valider</span>
                </button>
              </div>
            </div>
          </form>
          <div class="is-margin-top-auto ">
            <div class="columns is-gapless is-align-items-flex-end">
              <div class="column is-narrow">
                <img
                  src="/img/vadimm/logo-vadimm--x2.png"
                  width="60"
                  alt="">
              </div>
              <div class="column is-margin-bottom-xsmall">
                <p class="has-text-right has-text-grey is-size-7">
                  <small>V. {{ $configs.APPVERSION }}</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { bus, EVENTS } from '@/bus'

export default {
  name: 'Register',
  data () {
    return {
      planList: [],
      freePlan: null,
      email: null,
      address: null,
      phone: null,
      password: null,
      firstName: null,
      lastName: null,
      accountName: null,
      token: null,
      tokenIsValid: null,
      loading: false
    }
  },
  computed: {
    illustrationStyle () {
      let styleObject = {}
      if (this.$configs && this.$configs.ILLUSTRATION_LOGIN && this.$configs.ILLUSTRATION_LOGIN !== '') {
        styleObject.backgroundImage = 'url(\' ' + this.$configs.ILLUSTRATION_LOGIN + ' \')'
      } else {
        // styleObject.color = 'white'
        styleObject.backgroundImage = 'url(\'https://res.cloudinary.com/batiment-b/image/upload/crm-immo/public/login-illustration-min.jpg\')'
      }
      return styleObject
    },
    canSubmit () {
      return this.token
    },
    plan () {
      if (this.token) {
        return this.freePlan
      } else {
        return null
      }
    }
  },
  created () {
    this.initWidget()
    if ('token' in this.$route.query && this.$route.query.token && this.$route.query.token.length === 6) {
      this.token = this.$route.query.token
    }
  },
  methods: {
    initWidget () {
      this.getPlans()
    },
    async checkInvitationToken () {
      if (this.token && this.token.length === 6 && this.email && this.email.length > 4) {
        let request = await this.$api.axios.get('invitation-lookup', {
          params: {
            email: this.email,
            token: this.token
          }
        })
        this.tokenIsValid = request.data.valid
      }
    },
    async getPlans () {
      const params = {
        account_type: 'commercial'
      }
      try {
        let request = await this.$api.axios.get('available-plans', {
          params
        })
        this.planList = request.data
        this.freePlan = this.planList.find(x => x.plan_cost_by_month === 0)
      } catch (e) {
      }
    },
    async submitForm () {
      let formIsValid = await this.$validator.validateAll()
      if (formIsValid && this.plan) {
        let payload = {
          email: this.email,
          phone: this.phone,
          password: this.password,
          first_name: this.firstName,
          last_name: this.lastName,
          account_name: this.accountName,
          token: this.token,
          plan: this.plan.pk,
          address: this.address
        }
        let registerSuccess = false
        this.loading = true
        try {
          await this.$api.axios.post('register', payload)
          registerSuccess = true
        } catch (e) {
          this.$toasted.global.danger('Erreur d\'inscription !')
          this.loading = false
        }
        if (registerSuccess) {
          let request = await this.$api.axios.post('auth', {
            email: this.email,
            password: this.password
          })
          let token = request.data.access_token
          localStorage.setItem('token', token)
          bus.$emit(EVENTS.LOGIN, token)
          this.$router.push({ name: 'Dashboard' })
        }
      } else {
        this.$toasted.global.danger('Formulaire non valide')
      }
    }
  }
}
</script>
